import { size } from '@op/util'
import type { FieldValidator } from 'final-form'

export const minLength =
	(errorText: string, min: number): FieldValidator<string> =>
	(value) =>
		size(value) >= min ? undefined : errorText
